import { appBar, theme } from "../../utils/theme";

const HEIGHT = `calc(800px + ${appBar.height})`;

export const styles = {
  button: {
    backgroundColor: theme.palette.grays.white,
    color: theme.palette.secondary.main,
    overflow: "hidden",
    minWidth: 160,
    transition: "all 0.5s ease-in-out",
    width: { xs: "100%", md: "fit-content" },
    "&:hover": {
      backgroundColor: theme.palette.grays[300],
    },
  },
  buttonSecondary: {
    // color: theme.palette.grays.white,
    minWidth: 160,
    width: { xs: "100%", md: "fit-content" },
  },
  grow: {
    flexGrow: 1,
    marginLeft: "auto",
  },
  heroAction: {
    alignItems: "start",
    display: "flex",
    flexDirection: { xs: "column", sm: "row", md: "row" },
    gap: { xs: 4, sm: 5 },
    justifyContent: "start",
    width: "100%",
  },
  heroBackground: {
    backgroundPosition: "left top",
    backgroundRepeat: { xs: "no-repeat", md: "no-repeat" },
    backgroundSize: { xs: "cover", md: "cover" },
    height: "100%",
    top: -4,
    position: "absolute",
    width: "100%",
    zIndex: 0,
  },
  heroBody: {
    alignItems: { xs: "center", md: "start" },
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    width: { xs: "100%", md: "100%" },
  },
  heroContent: {
    alignItems: "start",
    display: "flex",
    flexDirection: "column",
    gap: 8,
    justifyContent: "center",
    position: "absolute",
    width: { xs: "90vw", xl: "60vw" },
  },
  heroContainer: {
    alignItems: "center",
    backgroundColor: theme.palette.primary.light,
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    justifyContent: "flex-start",
    overflow: "hidden",
    position: "relative",
    width: "100%",
  },
  heroForeground: {
    alignItems: "center",
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: { xs: "column-reverse", md: "row" },
    height: { xs: "100vh", sm: "60vh", md: "100vh" },
    justifyContent: "center",
    maxHeight: { md: HEIGHT },
    minHeight: { sm: 400 },
    overflow: "hidden",
    position: "relative",
    zIndex: 2,
  },
  heroHeader: {
    color: theme.palette.grays.white,
    fontSize: {
      xs: theme.typography.fontSize * 1.8,
      md: theme.typography.fontSize * 2.8,
    },
    fontWeight: 700,
    letterSpacing: 1.5,
    lineHeight: 1,
    textAlign: "start",
    textTransform: "capitalize",
    transition: "all 0.3s ease-in-out",
  },
  heroSubheader: {
    color: theme.palette.grays[100],
    fontSize: {
      xs: theme.typography.h4,
      md: theme.typography.h3,
    },
    fontWeight: 700,
    letterSpacing: 1.5,
    lineHeight: 1.2,
    textAlign: "start",
    textTransform: "capitalize",
    transition: "all 0.3s ease-in-out",
  },
  heroText: {
    color: theme.palette.primary.light,
    display: "flex",
    fontSize: {
      xs: theme.typography.body,
      md: theme.typography.h3,
    },
    fontWeight: 500,
    letterSpacing: 1.2,
    lineHeight: 1.2,
    maxWidth: { md: "800px" },
    textAlign: "start",
    textTransform: "capitalize",
  },
  heroWave: {
    height: "8%",
    bottom: -1,
    position: "absolute",
    width: "100%",
  },
  margin: {
    display: "flex",
    margin: theme.spacing(1),
  },
  video: {
    filter: "brightness(0.7) grayscale(0.3) hue-rotate(0deg)",
    height: "100vh",
    objectFit: "cover",
    position: "fixed",
    transition: "all 0.3s ease-in-out",
    width: "100%",
  },
};
